<script setup>
/** "Suggested by Claude" (services spec §8 P-8.4): Claude drafted it, and nobody has touched it since. */
import { useWasloI18n } from '../i18n.js';

const { t } = useWasloI18n();
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-md w-fit bg-n-blue-3 text-n-blue-11"
    data-waslo-claude-chip
  >
    <span class="size-3 i-lucide-sparkles" aria-hidden="true" />
    {{ t('WASLO.CLAUDE.CHIP') }}
  </span>
</template>
